export const buildEmailPreferencesOrEmpty = (data) => {
    if (!data) {
        return {
            isEmailPreferencesSet: false,
            email: null,
            isSubPremiumContent: false,
            isSubNewsletter: false,
            isSubEvents: false,
            isSubBlogs: false,
        };
    }
    return {
        isEmailPreferencesSet: data.isEmailPreferencesSet || false,
        email: data.email || null,
        isSubPremiumContent: data.isSubPremiumContent || false,
        isSubNewsletter: data.isSubNewsletter || false,
        isSubEvents: data.isSubEvents || false,
        isSubBlogs: data.isSubBlogs || false,
    };
};
